import { render, staticRenderFns } from "./PersonalMedicoInfoAcademica.vue?vue&type=template&id=52ac8dea&scoped=true"
import script from "./PersonalMedicoInfoAcademica.vue?vue&type=script&lang=js"
export * from "./PersonalMedicoInfoAcademica.vue?vue&type=script&lang=js"
import style0 from "./PersonalMedicoInfoAcademica.vue?vue&type=style&index=0&id=52ac8dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ac8dea",
  null
  
)

export default component.exports